module.exports = __webpack_public_path__ + "google_play_store_badge-498f8.svg";